import VCCreateCapitalCall from "./VCCreateCapitalCall";

export default VCCreateCapitalCall;
